import React, {useContext, useEffect, useState} from "react";

import './DirectoryList.scss'
import AppContext from "../context/AppContext";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faFolder, faSpinner} from "@fortawesome/free-solid-svg-icons";
import FavStar from "./FavStar";
import {useApi} from "../api";
import FileBrowser from "../views/FileBrowser";
import FilePreview from "./FilePreview";
import VideoList from "./VideoList";

type Props = {
    dir: string
}

export default ({ dir }: Props) => {
    const { setSelectedVideo } = useContext(AppContext)

    const [loading, setLoading] = useState(false)

    const [clips, setClips] = useState<VideoFile[]>([])

    const api = useApi()

    const load = async () => {
        setLoading(true)
        if (dir) {
            const { count, files } = await api.getClips(dir)
            setClips(files)

            setLoading(false)
        }
    }

    const reload = async (e: any) => {
        e.preventDefault()
        await load()
    }

    useEffect(() => {
        (async () => {
            await load()
        })()
    }, [dir]);

    return (
      <div className="clip-list">
          <h2>Clips</h2>

          { !loading ? (
            <a href="#" onClick={reload}>Reload</a>
          ) : null }

          {loading ? (
            <FontAwesomeIcon icon={faSpinner} spin/>
          ) : (
            <>
                {clips.length ? (
                  <>
                      <VideoList canBeSelected={false}
                                 showDirectory={true}
                                 loading={loading}
                                 showSort={false}
                                 files={clips}/>
                  </>
                ) : (
                  <div style={{ marginBottom: '20px' }}>No clips yet</div>
                )}
            </>
          )}
      </div>
    )
}